import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import client from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

/* AuthCallback — handles the #session_id=... fragment that Emergent OAuth
 * redirects back to. Per the playbook, this MUST be the very first thing
 * the router renders if the URL hash carries a session_id, BEFORE any
 * protected-route check.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refreshGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/admin/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        const r = await client.post("/auth/google/session", { session_id: sessionId }, { withCredentials: true });
        await refreshGoogle?.(r.data);
        toast.success(`Welcome, ${r.data.name || r.data.email}`);
        navigate("/admin", { replace: true });
      } catch (err) {
        const msg = err.response?.data?.detail || err.message || "Sign-in failed";
        toast.error(msg);
        navigate("/admin/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto rounded-full border-2 border-[#FF6B00] border-t-transparent animate-spin" />
        <p className="mt-4 text-xs uppercase tracking-[0.3em] text-[#FFB800]">Powering up Saiyan link...</p>
      </div>
    </div>
  );
}
